import React from 'react'

import { Portal, Tooltip, UnstyledButton } from '@mantine/core'
import cn from 'classnames'
import { observer } from 'mobx-react-lite'

import { useMst } from '#state'

import styles from './InlineElementMenuButton.module.scss'

interface InlineElementMenuButtonProps extends React.PropsWithChildren {
  onClick: () => void
  isPageless: boolean
}

export const InlineElementMenuButton = observer<InlineElementMenuButtonProps>(
  function InlineElementMenuButton(props) {
    const { onClick, isPageless } = props
    const { view, currentScript } = useMst()
    const currentBlockStartPos = currentScript?.pmEditor.currentBlockStartPos
    const editorView = currentScript?.pmEditor.editorView

    if (
      currentBlockStartPos === null ||
      currentBlockStartPos === undefined ||
      !editorView
    ) {
      return null
    }

    const blockTop = editorView.coordsAtPos(currentBlockStartPos).top
    const editorTop = editorView.dom.getBoundingClientRect().top
    const top = (blockTop - editorTop) / view.editorZoom

    return (
      <Portal target="#pm-host-wrapper">
        <Tooltip position="right" label="Tab or click to change element">
          <UnstyledButton
            tabIndex={0}
            className={cn(styles.elementMenu, {
              [styles.pageless]: isPageless,
            })}
            style={{ top }}
            onClick={onClick}
          >
            {props.children}
          </UnstyledButton>
        </Tooltip>
      </Portal>
    )
  },
)
